import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Badge/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Button/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Dropdown/Dropdown.js");
;
import(/* webpackMode: "eager", webpackExports: ["FocusTrap"] */ "/app/node_modules/@mui/base/FocusTrap/FocusTrap.js");
;
import(/* webpackMode: "eager", webpackExports: ["FormControl"] */ "/app/node_modules/@mui/base/FormControl/FormControl.js");
;
import(/* webpackMode: "eager", webpackExports: ["useFormControlContext"] */ "/app/node_modules/@mui/base/FormControl/useFormControlContext.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Input/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/app/node_modules/@mui/base/Menu/Menu.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/MenuButton/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/MenuItem/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Modal"] */ "/app/node_modules/@mui/base/Modal/Modal.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/NoSsr/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Option/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/OptionGroup/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Popper"] */ "/app/node_modules/@mui/base/Popper/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Portal/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Select/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Slider/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Snackbar/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Switch/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Tab/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/TablePagination/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/TabPanel/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Tabs/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/TabsList/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/TextareaAutosize/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Transitions/CssAnimation.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Transitions/CssTransition.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Unstable_NumberInput/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/Unstable_Popup/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/unstable_useModal/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/unstable_useNumberInput/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useAutocomplete/useAutocomplete.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useBadge/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useButton/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useDropdown/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useInput/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useMenu/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useMenuButton/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useMenuItem/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useOption/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useSelect/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useSlider/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useSnackbar/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useSwitch/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useTab/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useTabPanel/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useTabs/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/useTabsList/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/base/utils/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/@mui/icons-material/KeyboardArrowRightRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Alert/Alert.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/AlertTitle/AlertTitle.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Autocomplete/Autocomplete.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/AvatarGroup/AvatarGroup.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/CalendarPicker/CalendarPicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/CalendarPickerSkeleton/CalendarPickerSkeleton.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/ClockPicker/ClockPicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/DatePicker/DatePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/DateTimePicker/DateTimePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/DesktopDatePicker/DesktopDatePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/DesktopDateTimePicker/DesktopDateTimePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/DesktopTimePicker/DesktopTimePicker.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/LoadingButton/LoadingButton.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/LocalizationProvider/LocalizationProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Masonry/Masonry.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/MobileDatePicker/MobileDatePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/MobileDateTimePicker/MobileDateTimePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/MobileTimePicker/MobileTimePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/MonthPicker/MonthPicker.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Pagination/Pagination.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Pagination/usePagination.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/PaginationItem/PaginationItem.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/PickersDay/PickersDay.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Rating/Rating.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Skeleton/Skeleton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/SpeedDial/SpeedDial.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/SpeedDialAction/SpeedDialAction.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/SpeedDialIcon/SpeedDialIcon.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/StaticDatePicker/StaticDatePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/StaticDateTimePicker/StaticDateTimePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/StaticTimePicker/StaticTimePicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/TabContext/TabContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TabList/TabList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TabPanel/TabPanel.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/Timeline/Timeline.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TimelineConnector/TimelineConnector.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TimelineContent/TimelineContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TimelineDot/TimelineDot.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TimelineItem/TimelineItem.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TimelineOppositeContent/TimelineOppositeContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/TimelineSeparator/TimelineSeparator.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/TimePicker/TimePicker.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/ToggleButton/ToggleButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/lab/ToggleButtonGroup/ToggleButtonGroup.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/TreeItem/TreeItem.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/TreeView/TreeView.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/lab/YearPicker/YearPicker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Autocomplete/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Backdrop/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Breadcrumbs/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Button/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Card/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/CardActionArea/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/CardActions/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/CardContent/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/CardMedia/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Checkbox/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/FormControlLabel/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Grid/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Link/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/List/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/ListItem/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/ListItemText/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Modal/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Step/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/StepLabel/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Stepper/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/TextField/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useControlled/useControlled.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useForkRef/useForkRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useId/useId.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/utils/esm/useIsFocusVisible/useIsFocusVisible.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useLazyRef/useLazyRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useOnMount/useOnMount.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/usePreviousProps/usePreviousProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/utils/esm/useSlotProps/useSlotProps.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/utils/esm/useTimeout/useTimeout.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/app/src/components/common/Accordion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardCarousel"] */ "/app/src/components/common/CardCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogCard"] */ "/app/src/components/common/Cards/BlogCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FinalPriceCard"] */ "/app/src/components/common/Cards/FinalPriceCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PackageInfoCard"] */ "/app/src/components/common/Cards/PackageInfoCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CloudflareTurnstile"] */ "/app/src/components/common/CloudflareTurnstile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommonAutocomplete"] */ "/app/src/components/common/FormComponent/AutoComplete/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommonInput"] */ "/app/src/components/common/FormComponent/CommonInput/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SlotDatePicker"] */ "/app/src/components/common/FormComponent/SlotDatePicker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddressDetailsForm"] */ "/app/src/components/common/Forms/AddressDetailsForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MemberDetailsForm"] */ "/app/src/components/common/Forms/MemberDetailsForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectSlotForm"] */ "/app/src/components/common/Forms/SelectSlotForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageCarousel"] */ "/app/src/components/common/ImageCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/app/src/components/common/Input/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InputBar"] */ "/app/src/components/common/InputBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeftTabsPanel"] */ "/app/src/components/common/LeftTabsPanel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocationDialog"] */ "/app/src/components/common/LocationDialog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileFilters"] */ "/app/src/components/common/MobileFilters/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OverView"] */ "/app/src/components/common/OverView/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaginationSection"] */ "/app/src/components/common/PaginationSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteCitySync"] */ "/app/src/components/common/RouteCitySync/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBar"] */ "/app/src/components/common/SearchBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHeader"] */ "/app/src/components/common/SectionHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/app/src/components/common/Select/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/SidePanelMenu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddressSelectionMap"] */ "/app/src/components/entities/AddressSelectionMap/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Cart"] */ "/app/src/components/entities/Cart/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Drawer"] */ "/app/src/components/entities/Drawer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomFab"] */ "/app/src/components/entities/fab/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/entities/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddUhidProfileForm"] */ "/app/src/components/entities/Forms/AddUhidProfileForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookWalkInSlotForm"] */ "/app/src/components/entities/Forms/BookWalkInSlotForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CancelBookingForm"] */ "/app/src/components/entities/Forms/CancelBookingForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CheckoutForm"] */ "/app/src/components/entities/Forms/CheckoutForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/entities/Forms/RescheduleForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SlotForm"] */ "/app/src/components/entities/Forms/SlotForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UhidAddressForm"] */ "/app/src/components/entities/Forms/UhidAddressForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UhidProfileForm"] */ "/app/src/components/entities/Forms/UhidProfileForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/components/entities/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HealthCredit"] */ "/app/src/components/entities/HealthCredit/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomepageCallbackForm"] */ "/app/src/components/entities/HomepageCallbackForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogCallbackPopup"] */ "/app/src/components/entities/HomepageCallbackPopup/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InternationalizationSwitch"] */ "/app/src/components/entities/InternationalizationSwitch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginDrawer"] */ "/app/src/components/entities/LoginDrawer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OtpDrawer"] */ "/app/src/components/entities/OtpDrawer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PackagesSelectionWrapper"] */ "/app/src/components/entities/PackagesSelectionWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PatientDetail"] */ "/app/src/components/entities/PatientDetail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PatientSelection"] */ "/app/src/components/entities/PatientSelection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaymentGatewayLoader"] */ "/app/src/components/entities/PaymentGatewayLoader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileAuthValidator"] */ "/app/src/components/entities/ProfileAuthValidator/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsSection"] */ "/app/src/components/entities/StatsSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogsSection"] */ "/app/src/components/feature/Home/Blogs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MostBookedTestPackagesSection"] */ "/app/src/components/feature/Home/MostBookedTestPackagesSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PackagesSection"] */ "/app/src/components/feature/Home/PackagesSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/app/src/components/feature/Home/TestimonialsSection/index.tsx");
